import React from "react";
import Hero from "./Hero";

const LandingPageHeader = () => {
  return (
    <div>
      <section id="hero">
        <Hero />
      </section>
    </div>
  );
};

export default LandingPageHeader;
